module.exports = __webpack_public_path__ + "static/media/geschichte-mobiliar.cbdf7392.jpg";